















import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ShowMoreOverlay',
  setup() {
    const isOpen = ref(false);

    const handleToggle = () => {
      isOpen.value = !isOpen.value;
    };

    return { isOpen, handleToggle };
  }
});
